import axiosInstance from 'api/axiosInstance';

async function getPinnedCases(userID: number): Promise<any> {
	const data = await axiosInstance.get(
		`/api2.0/pinnedcases/GetPinnedCases?userID=${userID}`,
	);
	if (!data || !data.data)
		throw new Error('Failed to fetch timesheet entries');

	return data.data;
}

export default getPinnedCases;
